import QueryString from "qs";
import Layout from "../../layout/Layout";
import IndustryPage from "../../components/pages/IndustryPage";

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL;

export const getServerSideProps = async (ctx) => {
	if (process.env.NEXT_PUBLIC_CACHE_PAGES) {
		ctx.res.setHeader(
			"Cache-Control",
			"public, s-maxage=1800, stale-while-revalidate=59",
		);
	}

	const slug = ctx.params.slug;

	const query = QueryString.stringify(
		{
			filters: { slug: { $eq: slug } },
			populate: "deep",
		},
		{ encodeValuesOnly: false },
	);

	const apiRes = await fetch(
		`${baseUrl}/industries?${decodeURIComponent(query)}`,
	);
	const apiResData = await apiRes.json();

	// Ensure data is correctly extracted
	const data = apiResData?.data?.[0]?.attributes || {};
	const isNew = data.template === "main-v2"; // Extract isNew from server-side

	return {
		props: {
			apiResData,
			slug,
			isNew, // Passing isNew from server-side
		},
	};
};

const Industry = ({ apiResData, slug, isNew }) => {
	if (!apiResData?.data?.length) {
		return <div>Error: No data found</div>;
	}

	return (
		<div id="root">
			{/* <Header isNew={isNew} />  */}
			<div className="">
				<IndustryPage slug={slug} isNew={isNew} data={apiResData} />
			</div>
			{/* <Troofooter /> */}
		</div>
	);
};

Industry.getLayout = function getLayout(page, props) {
	return (
		<Layout isNew={props.isNew} slug={props.slug}>
			{page}
		</Layout>
	);
};

export default Industry;
